import { render, staticRenderFns } from "./SelfProdInBillList.vue?vue&type=template&id=3ab2c5c7&scoped=true&"
import script from "./SelfProdInBillList.vue?vue&type=script&lang=js&"
export * from "./SelfProdInBillList.vue?vue&type=script&lang=js&"
import style0 from "./SelfProdInBillList.vue?vue&type=style&index=0&id=3ab2c5c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab2c5c7",
  null
  
)

export default component.exports